import { Typography, Box } from "@mui/material";
import "./styles.css";

const CustomActionButton = ({ children, text }) => {
  return (
    <Box>
      <Box>{children}</Box>
      <Box>
        <Typography className="custom-action-button" gutterBottom>
          {text}
        </Typography>
      </Box>
    </Box>
  );
};

export default CustomActionButton;
